import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { tariffmanagementClient } from '@integration/api-client/tariffmanagement';

const { actions, effects } = generateNgrxServiceClient(
  'Tariffs',
  tariffmanagementClient
);

export { actions as tariffsActions, effects as tariffsEffects };
